import { OnboardingDone } from "@/features/portal/components/onboarding/onboarding-done";

/** `/portal/onboarding/done` — thank-you landing after a completed submission. */
export default function OnboardingDonePage() {
  return <OnboardingDone />;
}
